/**
 *
 * RichEditor
 *
 */

import React, { useEffect, useState, useCallback } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { useTranslation } from "react-i18next";

// styles
import './style.scss';

import { Editor } from 'react-draft-wysiwyg';
import 'react-draft-wysiwyg/dist/react-draft-wysiwyg.css';

import { EditorState, convertToRaw, ContentState } from 'draft-js';
//import { stateToHTML } from 'draft-js-export-html';
//import { stateFromHTML } from 'draft-js-import-html';

import draftToHtml from 'draftjs-to-html';
import htmlToDraft from 'html-to-draftjs';

import linkifyHtml from 'linkify-html';

// Icons for Editor Note: get insert only path to image, not svg code
// Note: get insert only path to image, not svg code
import iconOrderList from 'images/icons/ordered-list.svg';
import iconLink from 'images/icons/link.svg';

// global user
// import { withUser } from 'engine/Contexts/User.context';

function RichEditor({
  type,
  contentType,
  placeholder,
  content,
  handleChange,
  // default props
  className,
  ...rest
}) {
  const { t } = useTranslation();
  const styleMap = {
    CUSTOMLINK: {
      textDecoration: 'line-through',
      backgroundColor: '#faed27',
    },
  };

  const [focused, setFocused] = useState(false);
  const [editorState, setEditorState] = useState(EditorState.createEmpty());

  /**
   * Loading data for rendering in a component
   * - work like ComponentDidUpdate
   */
  useEffect(() => {
    /* 
    const currentContentHtml = stateFromHTML(content, {});
    const editorState = EditorState.createWithContent(currentContentHtml);
    */
    const contentBlock = htmlToDraft(content);
    const contentState = ContentState.createFromBlockArray(
      contentBlock.contentBlocks,
    );
    const editorState = EditorState.createWithContent(contentState);
    if (editorState) {
      setEditorState(editorState);
    }
  }, []);

  useEffect(() => {
    /* 
    const currentContentHtml = stateFromHTML(content, {});
    const editorState = EditorState.createWithContent(currentContentHtml);
    */
    const contentBlock = htmlToDraft(content);
    const contentState = ContentState.createFromBlockArray(
      contentBlock.contentBlocks,
    );
    const editorState = EditorState.createWithContent(contentState);
    if (editorState) {
      setEditorState(editorState);
    }
  }, [content]);

  const modifyLinkContent = content => {
    const options = {
      defaultProtocol: 'https',
      //target: '_blank'
    };
    return linkifyHtml(content, options);
  };

  const onEditorStateChange = useCallback(
    editorState => {
      setEditorState(editorState);
      const currentContent = editorState.getCurrentContent();
      const dataToSaveBackend = convertToRaw(currentContent);
      const editorContentHtml = draftToHtml(dataToSaveBackend);

      const updatedContent = modifyLinkContent(editorContentHtml);

   /*    // match any HTML tags and whitespace
      const regex = /<[^>]*>|^\s*$/gm; 
      // remove any HTML tags and whitespace
      const actualText = updatedContent.replace(regex, '').replace('\n', ''); 
      const prevText = content.replace(regex, '').replace('\n', ''); 
      console.log(prevText, actualText); */
      handleChange(updatedContent)
    },
    [content],
  );

  /*   const onContentStateChangeCallback = useCallback(
    rawDraftContentState => {
      const editorContentHtml = draftToHtml(rawDraftContentState);

      const updatedContent = modifyLinkContent(editorContentHtml);
      handleChange(updatedContent);
    },
    [content],
  ); */

  const formatLink = obj => {
    try {
      /*  if (obj.target.includes('http://localhost:3000/')) {
        obj.targetOption = '_self';
        const newTarget = obj.target.replace('http://localhost:3000/', '/');
        obj.target = newTarget;
      }
      if (obj.target.includes('http://localhost:3000/')) {
        obj.targetOption = '_self';
        const newTarget = obj.target.replace('http://localhost:3000/', '/');
        obj.target = newTarget;
      } */
      return obj;
    } catch (e) {
      return obj;
    }
  };

  const editorLabels = {
    // Generic
    'generic.add': t("common.added"),
    'generic.cancel': t("common.cancel"),

    // BlockType
    'components.controls.blocktype.h1': 'Titre 1',
    'components.controls.blocktype.h2': 'Titre 2',
    'components.controls.blocktype.h3': 'Titre 3',
    'components.controls.blocktype.h4': 'Titre 4',
    'components.controls.blocktype.h5': 'Titre 5',
    'components.controls.blocktype.h6': 'Titre 6',
    'components.controls.blocktype.blockquote': 'Citation',
    'components.controls.blocktype.code': 'Code',
    'components.controls.blocktype.blocktype': 'Type bloc',
    'components.controls.blocktype.normal': 'Normal',

    // Color Picker
    'components.controls.colorpicker.colorpicker': 'Palette de couleur',
    'components.controls.colorpicker.text': 'Texte',
    'components.controls.colorpicker.background': 'Fond',

    // Embedded
    'components.controls.embedded.embedded': 'Embedded',
    'components.controls.embedded.embeddedlink': 'Lien iFrame',
    'components.controls.embedded.enterlink': 'Entrer le lien',

    // Emoji
    'components.controls.emoji.emoji': 'Emoji',

    // FontFamily
    'components.controls.fontfamily.fontfamily': 'Police',

    // FontSize
    'components.controls.fontsize.fontsize': 'Taille de police',

    // History
    'components.controls.history.history': 'Historique',
    'components.controls.history.undo': t("common.previous"),
    'components.controls.history.redo': t("common.next"),

    // Image
    'components.controls.image.image': 'Image',
    'components.controls.image.fileUpload': 'Téléchargement',
    'components.controls.image.byURL': 'URL',
    'components.controls.image.dropFileText':
      'Glisser une image ou cliquer pour télécharger',

    // Inline
    'components.controls.inline.bold': 'Gras',
    'components.controls.inline.italic': 'Italique',
    'components.controls.inline.underline': 'Souligner',
    'components.controls.inline.strikethrough': 'Barrer',
    'components.controls.inline.monospace': 'Monospace',
    'components.controls.inline.superscript': 'Exposant',
    'components.controls.inline.subscript': 'Indice',

    // Link
    'components.controls.link.linkTitle': 'Titre du lien',
    'components.controls.link.linkTarget': 'Cible du lien',
    'components.controls.link.linkTargetOption':
      'Ouvrir le lien dans une nouvelle fenêtre',
    'components.controls.link.link': 'Lier',
    'components.controls.link.unlink': 'Délier',

    // List
    'components.controls.list.list': 'Liste',
    'components.controls.list.unordered': 'Désordonnée',
    'components.controls.list.ordered': 'Ordonnée',
    'components.controls.list.indent': 'Augmenter le retrait',
    'components.controls.list.outdent': 'Diminuer le retrait',

    // Remove
    'components.controls.remove.remove': 'Supprimer',

    // TextAlign
    'components.controls.textalign.textalign': 'Alignement du texte',
    'components.controls.textalign.left': 'Gauche',
    'components.controls.textalign.center': 'Centre',
    'components.controls.textalign.right': 'Droite',
    'components.controls.textalign.justify': 'Justifier',
  };

  const blockType = {
    inDropdown: true,
    options: ['Normal', 'H1', 'H2', 'H3', 'H4', 'H5', 'H6', 'Blockquote'],
    displayNames: [
      { label: 'Normal', displayName: 'Normal', style: 'unstyled' },
      { label: 'H1', displayName: 'Heading 1', style: 'header-one' },
      { label: 'H2', displayName: 'Heading 2', style: 'header-two' },
      { label: 'H3', displayName: 'Heading 3', style: 'header-three' },
      { label: 'H4', displayName: 'Heading 4', style: 'header-four' },
      { label: 'H5', displayName: 'Heading 5', style: 'header-five' },
      { label: 'H6', displayName: 'Heading 6', style: 'header-six' },
      { label: 'Blockquote', displayName: 'Blockquote', style: 'blockquote' },
    ],
    className: 'tcf-richEditor-block_types',
  };

  const editorToolbar = {
    options: [
      'blockType',
      'inline',
      'list',
      'link',
      'textAlign',
      'remove',
      'history',
    ],
    inline: {
      options: ['bold', 'italic', 'underline'],
      className: 'tcf-richEditor-inline',
    },
    list: {
      options: ['unordered', 'ordered'],
      ordered: { icon: iconOrderList, className: 'option-icon' },
      className: 'tcf-richEditor-list',
    },
    link: {
      className: 'tcf-richEditor-link',
      popupClassName: 'tcf-richEditor-link-popup',
      // dropdownClassName: undefined,
      showOpenOptionOnHover: false,
      defaultTargetOption: '_blank',
      options: ['link'], //'unlink'
      link: { icon: iconLink, className: 'option-icon' },
      // unlink: { icon: unlink, className: undefined },
      linkCallback: obj => formatLink(obj),
    },
    textAlign: {
      inDropdown: false,
      className: 'tcf-richEditor-text_align',
    },
    blockType,
  };

  return (
    <Editor
      {...rest}
      editorState={editorState}
      onEditorStateChange={onEditorStateChange}
      placeholder={placeholder || `Start typing your ${contentType} here...`}
      toolbarClassName="tcf-richEditor-toolbar"
      wrapperClassName={classNames(
        'tcf-richEditor-wrapper',
        // focused && 'tcf-richEditor-wrapper--focused',
        rest.className,
      )}
      editorClassName="tcf-richEditor"
      toolbar={editorToolbar}
      customStyleMap={styleMap}
      // onContentStateChange={onContentStateChangeCallback}
      onFocus={e => {
        setFocused(true);
        rest.onFocus && rest.onFocus(e);
      }}
     /*  onBlur={(event, editorState) => {
        focused && onEditorStateChange(editorState);
        setFocused(false);
        rest.onBlur && rest.onBlur(event, editorState);
      }} */
      localization={{ locale: 'fr', translations: editorLabels }}
      handlePastedText={(text, html, editorState, onChange) => {
        focused && onEditorStateChange(editorState);
        setFocused(false);
        rest.handlePastedText && rest.handlePastedText(text, html, editorState, onChange);
        return false;
      }}
      handleReturn={(event, editorState) => {
        focused && onEditorStateChange(editorState);
        setFocused(false);
        rest.handleReturn && rest.handleReturn(event, editorState);
      }}
    />
  );
}

RichEditor.defaultProps = {
  type: 'simple',
  contentType: 'text',
  placeholder: '',
};
RichEditor.propTypes = {
  type: PropTypes.oneOf(['simple', 'full']),
};

export default RichEditor;
